import { createTheme } from '@mui/material/styles'

const theme = (darkMode) =>
  createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
    typography: {
      h1: {
        fontSize: '2.5rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '2.2rem',
        },
        '@media (max-width:600px)': {
          fontSize: '2rem',
        },
      },
      h2: {
        fontSize: '2.25rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '2rem',
        },
        '@media (max-width:600px)': {
          fontSize: '1.8rem',
        },
      },
      h3: {
        fontSize: '2rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '1.8rem',
        },
        '@media (max-width:600px)': {
          fontSize: '1.6rem',
        },
      },
      h4: {
        fontSize: '1.75rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '1.6rem',
        },
        '@media (max-width:600px)': {
          fontSize: '1.4rem',
        },
      },
      h5: {
        fontSize: '1.5rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '1.4rem',
        },
        '@media (max-width:600px)': {
          fontSize: '1.2rem',
        },
      },
      h6: {
        fontSize: '1.25rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '1.2rem',
        },
        '@media (max-width:600px)': {
          fontSize: '1rem',
        },
      },
      body1: {
        fontSize: '1rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '0.9rem',
        },
        '@media (max-width:600px)': {
          fontSize: '0.8rem',
        },
      },
      body2: {
        fontSize: '0.875rem',
        '@media (min-width:601px) and (max-width:960px)': {
          fontSize: '0.875rem',
        },
        '@media (max-width:600px)': {
          fontSize: '0.8rem',
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  })

export default theme
